module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/signin/signin.component.html
// module id = ./src/app/components/signin/signin.component.html
// module chunks = main